<template>
  <v-container fluid class="pa-4">
    <v-row>
      <v-col cols="12">
        <v-progress-circular v-if="loading" indeterminate color="primary" />
        <template v-else-if="warehouseId">
          <v-tabs v-model="activeTab" background-color="white" color="primary" class="mb-4">
            <v-tab>Nov ispravak</v-tab>
            <v-tab>Povijest ispravaka</v-tab>
          </v-tabs>

          <nov-ispravak
            v-if="activeTab === 0"
            :warehouse-id="warehouseId"
            :location-id="locationId"
            :company-id="companyId"
          />
          <povijest-ispravaka
            v-if="activeTab === 1"
            :warehouse-id="warehouseId"
          />
        </template>
        <v-alert v-else type="warning">
          Nije pronađen skladište za ovu lokaciju.
        </v-alert>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { df } from '@/plugins/firebase'
import state from '@/state'
import NovIspravak from './ispravak-normativa/NovIspravak.vue'
import PovijestIspravaka from './ispravak-normativa/PovijestIspravaka.vue'

export default {
  name: 'IspravakNormativa',
  components: { NovIspravak, PovijestIspravaka },
  data () {
    return {
      activeTab: 0,
      warehouseId: null,
      loading: true
    }
  },
  computed: {
    companyId () {
      return state.getCurrentCompany().id
    },
    locationId () {
      return state.getPointOfSale()?.id || this.$route.params.locationId
    }
  },
  async created () {
    await this.loadWarehouse()
  },
  methods: {
    async loadWarehouse () {
      this.loading = true
      try {
        const snap = await df.collection('warehouses')
          .where('location_id', '==', this.locationId)
          .limit(1)
          .get()
        if (!snap.empty) {
          this.warehouseId = snap.docs[0].id
        }
      } finally {
        this.loading = false
      }
    }
  }
}
</script>
